import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { unsignedUploadDocumentReducer } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/reducers/unsigned-upload-document.reducer';
import { unsignedUploadDocumentStoreKey } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/store-config';
import { UnsignedUploadDocumentEffects } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/effects/unsigned-upload-document.effects';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(unsignedUploadDocumentStoreKey, unsignedUploadDocumentReducer), EffectsModule.forFeature([UnsignedUploadDocumentEffects])],
    exports: [],
    providers: []
})
export class UnsignedUploadDocumentStoreModule {}
